import { Injectable } from "@angular/core";
import { Router, NavigationEnd } from "@angular/router";
import { filter } from "rxjs/operators";

@Injectable({
    providedIn: "root",
})
export class QueryParamPreserverService {
    private langParam: string | null = null;

    constructor(private router: Router) {}

    init(): void {
        this.langParam = this.getLangParam();

        this.router.events
            .pipe(filter((event) => event instanceof NavigationEnd))
            .subscribe(() => {
                const currentLang = this.getLangParam();

                if (this.langParam && !currentLang) {
                    const urlTree = this.router.parseUrl(this.router.url);
                    urlTree.queryParams = {
                        ...urlTree.queryParams,
                        lang: this.langParam,
                    };
                    this.router.navigateByUrl(urlTree, { replaceUrl: true });
                } else if (currentLang) {
                    this.langParam = currentLang;
                }
            });
    }

    private getLangParam(): string | null {
        return new URLSearchParams(window.location.search).get("lang");
    }
}
